import { DISTRIBUTIONS_PATH } from 'devices/navigation';

module.exports = {
  path: DISTRIBUTIONS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DeviceDistributions'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/devices/routes/show/routes/distributions/index.js